import { jsx as t } from "react/jsx-runtime";
import { EditIcon as n } from "../../../icons/index.es.js";
import { chakra as i } from "@chakra-ui/react";
import { useAvatarStyle as m } from "../Avatar.context.es.js";
const p = ({ onEdit: o }) => {
  const r = m();
  return /* @__PURE__ */ t(i.button, { __css: r.button, onClick: o, type: "button", children: /* @__PURE__ */ t(n, {}) });
};
export {
  p as AvatarEdit
};
//# sourceMappingURL=AvatarEdit.es.js.map
